import { instance } from "../api-instance";

export const RegistrationApi = {
  createContact(data: unknown): Promise<unknown> {
    return instance.post("registration/createContact", data);
  },

  sendCode(data: unknown): Promise<unknown> {
    return instance.post("registration/sendCode", data);
  },

  resendCode(userId: unknown): Promise<unknown> {
    return instance.post("registration/resendCode", userId);
  },

  checkCode(data: unknown): Promise<unknown> {
    return instance.post("registration/checkCode", data);
  },

  async checkVerificationCodeResendTimeLeft(
    tempUserUserId: unknown
  ): Promise<unknown> {
    const res = await instance.post(
      "message/getVerificationCodeResendTimeLeft",
      tempUserUserId
    );
    return res.data;
  },
};
